// extracted by mini-css-extract-plugin
export var linkText = "_qm-0";